<app-header></app-header>

<div class="container-fluid table-div-termination">
  <div class="header-section">
    <div class="head">
      <div class="d-flex">
        <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
        <h4 class="form-title-sm">{{'Terminationn' | translate}}</h4>
      </div>
      <div class="custom-container">
      </div>
    </div>
  </div>
  <div class="table-div">
    <div class="serach-section">
      <div class="search-input">
        <label><i class="fa-solid fa-magnifying-glass hide"></i></label>
        <input type="text" placeholder="{{'Search employee' | translate}}"
          (keyup)="filterEmployees($any($event.target).value)">
      </div>
    </div>
    <div class="table_section" *ngIf="hasSearched && filteredEmployees.length > 0">
      <table class="table-responsive">
        <thead>
          <tr>
            <th>
              <p>{{'SL NO' | translate}}</p>
            </th>
            <th>
              <p>{{'PUPS ID' | translate}}</p>
            </th>
            <th>
              <p>{{'Name' | translate}}</p>
            </th>
            <th>
              <p>{{'NIP Number' | translate}}</p>
            </th>
            <th>
              <p>{{'Designation' | translate}}</p>
            </th>
            <th>
              <p>{{'CNAMGS ID' | translate}}</p>
            </th>
            <th>
              <p>{{'CNSS ID' | translate}}</p>
            </th>
            <th>
              <p>{{'Mobile' | translate}}</p>
            </th>
            <th>
              <p>{{'Action' | translate}}</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let employee of filteredEmployees; let i = index">
            <td>
              <p>{{ i + 1 }}</p>
            </td>
            <td>
              <p>{{ employee.ccps_code || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.name || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.nip_number || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.designation || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.cnamgs || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.cnss || '--' }}</p>
            </td>
            <td>
              <p>{{ employee.mobile || '--' }}</p>
            </td>

            <!-- <td class="action-div">
                            <button class="btn termination-btn" (click)="resignEmployee(employee)"><img src="assets/images/termination-img.png" alt=""></button>
                        </td> -->
            <td class="action-div">
              <button class="btn termination-btn" (click)="resignEmployee(employee)">
                <img src="assets/images/termination-img.png" alt="">
              </button>
            </td>

          </tr>
        </tbody>
      </table>
      <!-- <div class="no-data-section " *ngIf="filteredEmployees.length == 0">
                <img src="assets/images/user-no-found.jpg" alt="">
                <h5>{{ noDataMessage | translate}}</h5>
            </div> -->
    </div>
    <!-- <div class="no-data-section " *ngIf="!hasSearched">
            <img src="assets/images/user-no-found.jpg" alt="">
            <h5>{{ noDataMessage | translate}}</h5>
        </div> -->

    <!-- <ng-template #noEmployees>
            <div class="no-data-section">
                <img src="assets/images/user-no-found.jpg" alt="">
                <h5>{{ noDataMessage | translate }}</h5>
            </div>
        </ng-template> -->

    <div class="no-data-section" *ngIf="hasSearched && filteredEmployees.length === 0">
      <img src="assets/images/user-no-found.jpg" alt="">
      <h5>
        {{ noDataMessage }}
      </h5>
    </div>



  </div>
</div>

<app-footer></app-footer>

<div class="modal fade" id="employeeResignModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <div class="parent-container">
          <h5 class="form-title text-center">{{'Employee Resignation' | translate}}</h5>
          <form id="employeeResignForm" [formGroup]="resignationForm" (ngSubmit)="onSubmitResign()">
            <div class="user-data-container">
              <div class="user-data" *ngIf="employeeDetail">
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CCPS ID' | translate}}</label>
                  <h6>{{ employeeDetail.ccps_code }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Name' | translate}}</label>
                  <h6>{{ employeeDetail.name }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Company ID' | translate}}</label>
                  <h6>{{ employeeDetail.company_id }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Designation' | translate}}</label>
                  <h6>{{ employeeDetail.designation }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CNAMGS ID' | translate}}</label>
                  <h6>{{ employeeDetail.cnamgs }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'CNSS ID' | translate}}</label>
                  <h6>{{ employeeDetail.cnss }}</h6>
                </div>
                <div class="child-container">
                  <label class="labeltxt-sm">{{'Mobile' | translate}}</label>
                  <h6>{{ employeeDetail.mobile }}</h6>
                </div>
              </div>
            </div>
            <div class="input-container text-center input-box-white" [owlDateTimeTrigger]="dt42">
              <label class="labeltxt-sm">{{'Select Date of Resignation' | translate}}</label>
              <div class="date-field">
                <input class="" readonly [owlDateTime]="dt42" [min]="startat" name="dob" [max]="todayDate"
                  formControlName="date_of_resignation">
                <div class="calendar input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                </div>
              </div>
              <owl-date-time [pickerType]="'calendar'" #dt42></owl-date-time>
              <div *ngIf="rsubmitted && a.date_of_resignation.errors" class="invalid-feedback">
                <div *ngIf="a.date_of_resignation.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="input-container text-center input-box-white">
              <label class="labeltxt-sm text-center">{{'Reason for Resignation' | translate}}</label>
              <select type="text" name="reason_leaving" class="bootstrap-select text-center" formControlName="reason"
                (change)="setValidator($event)" [(ngModel)]="resignReason">
                <option value="null" disabled selected>{{'Please Select one' | translate}}</option>
                <option *ngFor="let id of resign_reason" value="{{ id.id }}">{{ id.name }}</option>
              </select>
              <div *ngIf="rsubmitted && a.reason.errors" class="invalid-feedback">
                <div *ngIf="a.reason.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="text-container" *ngIf="a.reason.value == 14">
              <textarea placeholder="{{'write reason here' | translate}}" formControlName="reason_type"></textarea>
              <div *ngIf="rsubmitted && a.reason_type.errors" class="invalid-feedback">
                <div *ngIf="a.reason_type.errors?.required" class="text-center">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <div class="child-container mt-4 text-center"
              *ngIf="a.reason.value == 3 || a.reason.value == 4 || a.reason.value == 13">
              <label for="resign_reason_document" class="labeltxt text-center" *ngIf="a.reason.value == 3">{{'Upload death certificate' | translate}}<span class="mandatory" *ngIf="!resign_reason_document">*</span> <span
                  *ngIf="resign_reason_document" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
              <label for="id_death_document" class="labeltxt text-center"
                *ngIf="a.reason.value == 4 || a.reason.value == 13">{{'Upload Health Certificate resign' | translate}}<span class="mandatory" *ngIf="!resign_reason_document">*</span> <span
                  *ngIf="resign_reason_document" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
              <label for="resign_reason_document" class="file-upload-card labeltxt" id="death-cer-upload">
                <div class="custom-container UploadIcon" id="death-certificate-upload">
                  <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                  <i class="fa fa-upload " aria-hidden="true"></i>
                </div>
              </label>
              <input class="" id="resign_reason_document" type="file" data-target="resign_reason_document"
                (change)="upload($event, 'idDeathDocument')">
              <a *ngIf="resign_reason_document" id="idDeathDocument" href="{{resign_reason_document}}" target="_blank"
                class="viewFile text-center">{{'Click to view File'|translate}}</a>
              <div *ngIf="rsubmitted && a.resign_reason_document.errors" class="invalid-feedback text-center m-0">
                <div class="text-danger pt-3" *ngIf="a.resign_reason_document.errors?.required">{{'This field is mandatory'|translate}}</div>
              </div>
            </div>
            <button type="button" id="submit_btn" class="btn btn-medium" (click)="resignationModalOpen()">{{'Submit' | translate}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="resignation-confirm-modal" class="modal fade rejectcalculate" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <!-- Modal content-->
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <div class="modal-body">
        <h5>{{'Are you sure you want to end this employment relationship' | translate}}</h5>
        <div class="buttonFlex">
          <button class="reject_color" data-dismiss="modal">{{'No' | translate}}</button>
          <button type="submit" form="employeeResignForm" class="accept_color">{{'Yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>